import { Action, Mutation, Module, VuexModule } from "vuex-module-decorators";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import {AxiosRequestConfig} from 'axios'

interface Partner {
  //password: string;
  // ref: string;
  // token: string;
  // createdAt: Date;
  // expiredAt: Date;
  customerIDRef: number;
  isAppointed: boolean;
  partnerBillAddress: string;
  partnerCode: string;
  partnerInvoicePrefix: string;
  partnerIsActive: boolean;
  partnerName: string;
  partnerNameShow: string;
  partnerTaxBranch: string;
  partnerTaxID: string;
  partnerTel: string;
  prefixName?: string;
  warehouseIDRef: number;
}

interface PartnerModuleInfo {
  partnerList: Array<Partner>;
  isFatching: boolean;
}

@Module
export default class PartnerModule extends VuexModule implements PartnerModuleInfo {

  partnerList = [];
  isFatching = false

  get getPartnerList(): Array<Partner> {
    return this.partnerList
  }

  get getFatchingStatus()
  {
    return this.isFatching
  }

  @Action
  [Actions.FETCH_PARTNER_LIST]() {
    return new Promise<void>((resolve, reject) => {
      // ถ้ามีการดึงข้อมูลอยู่
      if(this.isFatching) resolve()

      // เซ็ทว่ากำลังโหลดอยู่
      this.context.commit("FatchingPartner", true)

      //ดึงข้อมูล
      ApiService.query("data-options/partners", {})
      .then(({data}) => {      
        this.context.commit(Mutations.SET_PARTNER_LIST, data)
        this.context.commit("FatchingPartner", false)
        resolve()
      })
      .catch(({response}) => {
        
        this.context.commit("FatchingPartner", false)
        reject(response.data.message);
      })
    })
  }

  @Mutation
  [Mutations.SET_PARTNER_LIST](payload) {
    this.partnerList = payload;
  }
  
  @Mutation
  FatchingPartner(payload) {
    this.isFatching = payload;
  }
}
